// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-o_fC","advertDetailContactItem__link":"c-o_fE","advertDetailContactItem__stub":"c-o_fF"};